import { render, staticRenderFns } from "./DirectSaleCategories.vue?vue&type=template&id=7a94ffee"
import script from "./DirectSaleCategories.vue?vue&type=script&lang=js"
export * from "./DirectSaleCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports